import styled from 'styled-components';
import { Link } from 'react-router-dom';

export const NavbarContainer = styled.nav`
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  background: #ffffff;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.04);
  z-index: 1000;
  height: 56px;
`;

export const NavbarContent = styled.div`
  max-width: 1400px;
  margin: 0 auto;
  padding: 0 24px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  height: 100%;

  @media (max-width: 1024px) {
    padding: 0 12px;
  }
`;

export const Logo = styled.div`
  font-size: 20px;
  font-weight: bold;
  color: #333333;

  a {
    color: #333333;
    text-decoration: none;

    &:hover {
      color: #F1AF59;
    }
  }

  @media (max-width: 1024px) {
    font-size: 18px;
  }
`;

/* 移动端汉堡按钮：默认隐藏，≤768px 显示 */
export const Hamburger = styled.button`
  display: none;

  @media (max-width: 1024px) {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 44px;
    height: 44px;
    border: none;
    background: transparent;
    color: #333333;
    border-radius: 8px;
    cursor: pointer;

    &:hover { background: #f5f5f5; }

    svg { width: 26px; height: 26px; }
  }
`;

export const NavLinks = styled.div`
  display: flex;
  gap: 24px;
  flex: 1;
  margin-left: 48px;

  /* 移动端：变成从顶栏下拉的全宽抽屉，行更大更好点 */
  @media (max-width: 1024px) {
    position: fixed;
    top: 56px;
    left: 0;
    right: 0;
    margin-left: 0;
    flex-direction: column;
    gap: 0;
    background: #ffffff;
    box-shadow: 0 10px 20px rgba(0, 0, 0, 0.12);
    border-top: 1px solid #eee;
    max-height: calc(100dvh - 56px);
    overflow-y: auto;
    -webkit-overflow-scrolling: touch;
    padding: 6px 0 max(6px, env(safe-area-inset-bottom, 0px));
    z-index: 1001;
    transform: ${props => props.$mobileOpen ? 'translateY(0)' : 'translateY(-8px)'};
    opacity: ${props => props.$mobileOpen ? 1 : 0};
    visibility: ${props => props.$mobileOpen ? 'visible' : 'hidden'};
    transition: opacity 0.2s ease, transform 0.2s ease, visibility 0.2s ease;
  }
`;

export const NavLink = styled(Link)`
  color: ${props => props.$isActive ? '#fff' : '#333333'};
  text-decoration: none;
  font-size: 15px;
  font-weight: ${props => props.$isActive ? '600' : '500'};
  padding: 8px 16px;
  border-radius: 6px;
  transition: all 0.2s;
  background: ${props => props.$isActive ? '#F1AF59' : 'transparent'};

  &:hover {
    background: ${props => props.$isActive ? '#F1AF59' : '#f5f5f5'};
    color: ${props => props.$isActive ? '#fff' : '#F1AF59'};
  }

  @media (max-width: 1024px) {
    display: block;
    width: 100%;
    padding: 14px 20px;
    font-size: 16px;
    border-radius: 0;
    background: ${props => props.$isActive ? '#F1AF59' : 'transparent'};
  }
`;

export const RoleSwitcher = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
`;

export const RoleLabel = styled.span`
  color: #666666;
  font-size: 14px;
  font-weight: 500;
`;

export const RoleSelect = styled.select`
  padding: 6px 12px;
  border-radius: 6px;
  border: 1px solid #d1d5db;
  background: #ffffff;
  color: #333333;
  font-size: 14px;
  cursor: pointer;

  &:focus {
    outline: none;
    border-color: #F1AF59;
  }

  option {
    background: #ffffff;
    color: #333333;
  }
`;

export const RoleBadge = styled.span`
  padding: 6px 12px;
  border-radius: 20px;
  font-size: 13px;
  font-weight: 600;
  background: ${props => {
    if (props.$role === 'system_admin') return '#dc2626'; // Red
    if (props.$role === 'director') return '#f59e0b'; // Orange
    if (props.$role === 'manager') return '#8b5cf6'; // Purple
    if (props.$role === 'admin') return '#a855f7'; // Light Purple
    if (props.$role === 'teacher') return '#10b981'; // Green
    if (props.$role === 'parent') return '#3b82f6'; // Blue
    return '#6b7280';
  }};
  color: white;
`;

export const DropdownContainer = styled.div`
  position: relative;
  display: inline-block;

  @media (max-width: 1024px) {
    display: block;
    width: 100%;
  }
`;

export const DropdownButton = styled.button`
  color: ${props => props.$isActive ? '#fff' : '#333333'};
  background: ${props => props.$isActive ? '#F1AF59' : 'transparent'};
  border: none;
  padding: 8px 16px;
  font-family: inherit;
  font-size: 15px;
  font-weight: ${props => props.$isActive ? '600' : '500'};
  cursor: pointer;
  border-radius: 6px;
  transition: all 0.2s;
  display: flex;
  align-items: center;
  gap: 6px;

  &:hover {
    background: ${props => props.$isActive ? '#F1AF59' : '#f5f5f5'};
    color: ${props => props.$isActive ? '#fff' : '#F1AF59'};
  }

  &::after {
    content: '▼';
    font-size: 10px;
    transition: transform 0.2s;
    transform: ${props => props.$isOpen ? 'rotate(180deg)' : 'rotate(0)'};
  }

  @media (max-width: 1024px) {
    width: 100%;
    justify-content: space-between;
    padding: 14px 20px;
    font-size: 16px;
    border-radius: 0;
  }
`;

export const DropdownMenu = styled.div`
  position: absolute;
  top: 100%;
  left: 0;
  margin-top: 8px;
  background: white;
  border-radius: 8px;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.15);
  min-width: 200px;
  z-index: 1001;
  opacity: ${props => props.$isOpen ? 1 : 0};
  visibility: ${props => props.$isOpen ? 'visible' : 'hidden'};
  transform: ${props => props.$isOpen ? 'translateY(0)' : 'translateY(-10px)'};
  transition: all 0.2s;
  overflow: hidden;

  /* 移动端：内嵌折叠（手风琴），不再悬浮 */
  @media (max-width: 1024px) {
    position: static;
    margin-top: 0;
    min-width: 0;
    border-radius: 0;
    box-shadow: none;
    background: #f9fafb;
    opacity: 1;
    visibility: visible;
    transform: none;
    max-height: ${props => props.$isOpen ? '70vh' : '0'};
    transition: max-height 0.25s ease;
  }
`;

export const DropdownLink = styled(Link)`
  display: block;
  padding: 12px 20px;
  color: #374151;
  text-decoration: none;
  font-size: 14px;
  font-weight: 500;
  transition: all 0.2s;
  border-left: 3px solid transparent;

  &:hover {
    background: #fef3e2;
    color: #F1AF59;
    border-left-color: #F1AF59;
  }

  &.active {
    background: #fef3e2;
    color: #F1AF59;
    border-left-color: #F1AF59;
  }

  @media (max-width: 1024px) {
    padding: 13px 20px 13px 36px;
    font-size: 15px;
  }
`;

export const SettingsIcon = styled(Link)`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 36px;
  height: 36px;
  border-radius: 50%;
  background: #f5f5f5;
  color: #333333;
  transition: all 0.2s;
  margin-left: 12px;

  &:hover {
    background: #F1AF59;
    color: white;
    transform: rotate(90deg);
  }

  svg {
    width: 20px;
    height: 20px;
  }
`;

export const UserActions = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  margin-left: 16px;
  padding-left: 16px;
  border-left: 1px solid #e5e7eb;

  @media (max-width: 1024px) {
    gap: 4px;
    margin-left: 6px;
    padding-left: 6px;
  }
`;

export const ActionButton = styled.button`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 36px;
  height: 36px;
  border-radius: 50%;
  background: #f5f5f5;
  color: #333333;
  border: none;
  cursor: pointer;
  transition: all 0.2s;

  &:hover {
    background: ${props => props.$variant === 'logout' ? '#ef4444' : '#F1AF59'};
    color: white;
  }

  &:disabled {
    opacity: 0.5;
    cursor: not-allowed;
  }

  svg {
    width: 18px;
    height: 18px;
  }

  @media (max-width: 1024px) {
    width: 40px;
    height: 40px;
    svg { width: 20px; height: 20px; }
  }
`;

export const RefreshButton = styled(ActionButton)`
  &:hover svg {
    animation: spin 0.5s ease-in-out;
  }

  @keyframes spin {
    from {
      transform: rotate(0deg);
    }
    to {
      transform: rotate(360deg);
    }
  }
`;

export const NotificationButton = styled(ActionButton)`
  position: relative;

  &:hover {
    background: #F1AF59;
    color: white;
  }
`;
